module.exports = __webpack_public_path__ + "images/temporaryStopHover.b94872aa528333b8d31fec6475010e2b.png";